const indexItems = [
  { letter: 'A-Z', title: '全部漫画', desc: '按字母索引浏览全站漫画', icon: 'ri-book-open-line', color: 'text-primary-500 bg-primary-100' },
  { letter: '韩', title: '韩漫推荐', desc: '韩国漫画精选合集', icon: 'ri-kakao-talk-line', color: 'text-accent-500 bg-accent-100' },
  { letter: '日', title: '日漫大全', desc: '日本漫画完整收录', icon: 'ri-global-line', color: 'text-primary-500 bg-primary-100' },
  { letter: '国', title: '国漫排行榜', desc: '国产漫画热门排行', icon: 'ri-flag-2-line', color: 'text-secondary-600 bg-secondary-100' },
  { letter: '热', title: '热血战斗', desc: '燃爆全场的战斗漫画', icon: 'ri-fire-line', color: 'text-accent-500 bg-accent-100' },
  { letter: '恋', title: '甜蜜恋爱', desc: '心动不已的恋爱漫画', icon: 'ri-heart-line', color: 'text-primary-500 bg-primary-100' },
  { letter: '悬', title: '悬疑推理', desc: '烧脑刺激的悬疑漫画', icon: 'ri-lightbulb-line', color: 'text-secondary-600 bg-secondary-100' },
  { letter: '新', title: '最新上架', desc: '每日更新的最新漫画', icon: 'ri-sparkling-line', color: 'text-accent-500 bg-accent-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">漫画索引</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            快速浏览<strong>漫画大全</strong>，按分类精准定位你感兴趣的<strong>好看的漫画</strong>
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.letter}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 border border-background-200/60 rounded-xl hover:border-primary-200/60 hover:bg-background-100 transition-all cursor-pointer text-center"
            >
              <div className={`w-12 h-12 rounded-full flex items-center justify-center ${item.color} mb-3 text-lg font-heading`}>
                {item.letter}
              </div>
              <h3 className="font-serif font-semibold text-sm md:text-base text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}